/** InsCoder WANG.J 2026-07-08 B + Hide cart progress bar when discount-section GWP is disabled **/
class CartProgressBar extends HTMLElement {
  constructor() {
    super();
    this.renderCartProgressBar();
  }

  renderCartProgressBar() {
    // When the discount_section_gwp section is disabled, promotionSettings is not defined
    if (!window.promotionSettings || !window.promotionSettings.gwp || window.promotionSettings.gwp.length === 0) {
      this.hidden = true;
      return;
    }

    const cartProgressBar = this.querySelector('[data-js-cart-progress-bar]');
    if (!cartProgressBar || !window.progressBar) return;

    const hasMeter = Boolean(cartProgressBar.querySelector('.price-progress-bar .meter'));
    if (hasMeter) {
      window.progressBar(this);
      return;
    }

    fetch('?section_id=helper-cart-progress-bar')
      .then((response) => response.text())
      .then((text) => {
        const innerHTML = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('[data-js-cart-progress-bar]');

        if (innerHTML) {
          cartProgressBar.innerHTML = innerHTML.innerHTML;
          window.progressBar(this);
        }
      });
  }
}

if (typeof customElements.get('cart-progress-bar') === 'undefined') {
  customElements.define('cart-progress-bar', CartProgressBar);
}
/** InsCoder WANG.J 2026-06-22 E + Cart drawer GWP progress bar custom element **/
